export const policyMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/policy/shipment/serviceabilities',
    label: 'Policy Manager',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" d="M12 2L4 5v6c0 5.52 3.58 10.74 8 12 4.42-1.26 8-6.48 8-12V5l-8-3zM12 4.24l6 2.18v5.73c0 4.52-2.91 8.91-6 10.31-3.09-1.4-6-5.79-6-10.31V6.42l6-2.18zm1 5.76v-2h-2v2H8v2h3v2h2v-2h3v-2h-3z" />
        </svg>
    ),

    Description: 'Policy manager centralizes and simplifies the administration, creation, and enforcement of policies, ensuring compliance, consistency, and control across the platform.',
    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Serviceability',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M19 2H5C3.9 2 3 2.9 3 4V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V4C21 2.9 20.1 2 19 2ZM19 4V6H5V4H19ZM5 20V8H19V20H5ZM7 11H17V13H7V11ZM7 15H17V17H7V15Z" />
                </svg>

            ),
            path: '/management/policy/shipment/serviceabilities',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Rate Cards',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M19 2H5C3.9 2 3 2.9 3 4V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V4C21 2.9 20.1 2 19 2ZM19 4V6H5V4H19ZM5 20V8H19V20H5ZM7 11H17V13H7V11ZM7 15H17V17H7V15Z" />
                </svg>

            ),
            path: '/management/policy/shipment/rate-cards',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Assistance Programs',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#007BFF">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path d="M18 2H6v2h12V2zM4 6h16v2H4V6zm-2 4h20v12H2V10zm18 10v-8H4v8h16z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            path: '/management/logistics/assistance-programs',
            isEnabled: true,

        },
    ],
}
)
